<template lang="pug">
.mb-5
    template(v-if="optInOutData?.length > 0")
        div(v-for='optInOut in optInOutData')
            ExpandableCardListItem.mt-0.mb-4.mr-5(
                :color="optInOut.action === 'Subscribe' ? 'success' : 'error'"
                :content-right-top="optInOut.action"
                :content-right-bottom="optInOut.friendlyDate"
                :is-expanded="isExpanded(optInOut.key)"
                :on-expand="() => { expandItem(optInOut.key) }"
                :subtitle="optInOut.communication"
                :title="optInOut.communicationType"
                :icon="optInOut.communicationIcon"
                expandable
            )
                template(v-slot:titleAppend)
                    v-tooltip(v-if="optInOut.sharedContact" top max-width="320")
                        template(v-slot:activator="{ on, attrs }")
                            v-chip.ml-2(v-bind="attrs" v-on="on" x-small label color="white" text-color="black")
                                | {{ optInOut.sharedContact.label }}
                        span {{ optInOut.sharedContact.description }}
                template(v-slot:rightTop)
                    strong {{ optInOut.action }}
                template(v-slot:body)
                    div(style="border-left: 2px outset var(--lt-gray); border-right: 2px inset var(--lt-gray)")
                        v-card-text.white.text--primary(v-if="isExpanded(optInOut.key)" style="padding-left: 0px;")
                            v-list.py-0(
                                two-line
                            )
                                v-row
                                    v-col(cols=6)
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Created At
                                                v-list-item-subtitle.visible-overflow {{ `${optInOut.friendlyDate}, ${optInOut.friendlyTime}` }}
                                    v-col(cols=6)
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Source
                                                v-list-item-subtitle.visible-overflow {{ optInOut.source }}
                                    v-col(cols=6)
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Responsible
                                                v-list-item-subtitle.visible-overflow {{ optInOut.responsibleType }}
                                    v-col(cols=6)
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Responsible
                                                v-list-item-subtitle.visible-overflow {{ optInOut.responsibleName || '---' }}
                                    v-col(cols=12 v-if="optInOut.sharedContact")
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Why This Applies
                                                v-list-item-subtitle.visible-overflow {{ optInOut.sharedContact.description }}
                                    v-col(cols=12)
                                        v-list-item(style="padding-left: 0px;")
                                            v-list-item-icon
                                            v-list-item-content
                                                v-list-item-title
                                                    strong.text-uppercase Notes
                                                v-list-item-subtitle.visible-overflow
                                                    StrLimitTooltipText(:text="optInOut.notes || '---'" :char-limit="15")
    template(v-else)
        v-alert.text-center(type="info" :icon="false" outlined dense)
            | No opt in out history found for this customer
</template>

<script lang="ts">
import Vue from 'vue';

// Components
import ExpandableCardListItem from '@/components/shared/expandable_card_list_item.vue';
import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

// helpers
import { formatTel } from "@/helpers/general";

export default Vue.extend({
    data() {
        return {
            expandedItems: [],
            optInOutData: [],
        }
    },
    methods: {
        constructHistoryData() {
            this.optInOutData = [];

            if (!(this.optInOuts?.length > 0)) {
                return;
            }

            function formatInternalText(str) {
                if (!(str?.length > 0)) {
                    return '---';
                }

                return str
                    .split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
            }

            for (let i = 0; i < this.optInOuts.length; i++) {
                const optInOut = this.optInOuts[i];
                const formattedDates = this.parseTimeString(optInOut);
                const communicationInfo = this.getCommunicationInfo(optInOut);

                const newOptInOutObject = {
                    action:             formatInternalText(optInOut.action),
                    communication:      communicationInfo[2],
                    communicationIcon:  communicationInfo[1],
                    communicationType:  communicationInfo[0],
                    friendlyDate:       formattedDates[0],
                    friendlyTime:       formattedDates[1],
                    key:                optInOut.opt_in_out_key,
                    notes:              optInOut.notes,
                    responsibleName:    optInOut.responsible_name,
                    responsibleType:    formatInternalText(optInOut.responsible_type),
                    sharedContact:      this.getSharedContactInfo(optInOut),
                    source:             formatInternalText(optInOut.source),
                }

                this.optInOutData.push(newOptInOutObject);
            }

            // this.optInOutData.sort((a, b) => a.communicationType.localeCompare(b.communicationType));
        },
        expandItem(key) {
            if (this.expandedItems?.includes(key)) {
                this.expandedItems = this.expandedItems.filter(item => item !== key);
            } else {
                this.expandedItems.push(key);
            }
        },
        getCommunicationInfo(optInOut) {
            const outgoing = [ '---', '---', '---', ];

            if (!(optInOut?.communication_type?.length > 0)) {
                return outgoing;
            }

            switch (optInOut.communication_type) {
                case 'all':
                    outgoing[0] = 'All';
                    outgoing[1] = 'mdi-check-all';
                    break;
                case 'email':
                    outgoing[0] = 'Email';
                    outgoing[1] = 'mdi-email';
                    break;
                case 'message':
                    outgoing[0] = 'Message';
                    outgoing[1] = 'mdi-cellphone';
                    break;
                case 'phone':
                    outgoing[0] = 'Call';
                    outgoing[1] = 'mdi-phone';
                    break;
            }

            if (optInOut.contactable_id > 0) {
                // Contactable ids point at the root level new_phone_numbers / new_email_addresses rows,
                // not the per organization phone_numbers / email_addresses rows
                if (optInOut.contactable_type === 'phone_number') {
                    for (let i = 0; i < this.communicationManager?.customer_phone_numbers?.length; i++) {
                        const phoneNumber = this.communicationManager.customer_phone_numbers[i];

                        if (phoneNumber.new_phone_number_id === optInOut.contactable_id) {
                            outgoing[2] = formatTel(phoneNumber.phone_number_phone_number);
                            break;
                        }
                    } 
                } else if (optInOut.contactable_type === 'email_address') {
                    for (let i = 0; i < this.communicationManager?.customer_email_addresses?.length; i++) {
                        const emailAddress = this.communicationManager.customer_email_addresses[i];

                        if (emailAddress.new_email_address_id === optInOut.contactable_id) {
                            outgoing[2] = emailAddress.email_address_email;
                            break;
                        }
                    }
                }
            } else {
                outgoing[2] = 'General';
            }
            
            return outgoing;
        },
        getSharedContactInfo(optInOut) {
            if (!optInOut.is_shared_contact) {
                return null;
            }

            switch (optInOut.optable_type) {
                case 'phone_number':
                    return {
                        label: 'Number Level',
                        description: 'This was not recorded on this customer. It applies to the phone number itself, so it affects every customer record using that number.',
                    };
                case 'email_address':
                    return {
                        label: 'Address Level',
                        description: 'This was not recorded on this customer. It applies to the email address itself, so it affects every customer record using that address.',
                    };
            }

            return null;
        },
        isExpanded(key) {
            return this.expandedItems?.includes(key);
        },
        parseTimeString(optInOut) {
            if (optInOut.friendly_created_at_date && optInOut.friendly_created_at_time) {
                return [optInOut.friendly_created_at_date, optInOut.friendly_created_at_time];
            }

            // Remove microseconds
            const cleanedIso = optInOut.created_at.replace(/\.\d+Z$/, 'Z');
            const date = new Date(cleanedIso);

            // Abbreviated month names
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

            // Extract date components
            const day = date.getUTCDate();
            const month = monthNames[date.getUTCMonth()];
            const year = date.getUTCFullYear();
            const formattedDate = `${month} ${day}, ${year}`;

            // Extract time components
            let hours = date.getUTCHours();
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            const formattedTime = `${hours}:${minutes} ${ampm}`;

            return [formattedDate, formattedTime];
        },
    },
    computed: {
    },
    components: {
        ExpandableCardListItem,
        StrLimitTooltipText,
    },
    props: {
        communicationManager: Object,
        optInOuts: Array,
    },
    watch: {
        optInOuts: {
            handler(newVal, oldVal) {
                this.constructHistoryData();
            },
            deep: true,
        }
    },
    created() {
        this.constructHistoryData();
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

.visible-overflow {
    overflow: visible !important;
    text-overflow: visible !important;
    white-space: wrap !important;
}

</style>